export default class ContributorDomain {
    constructor(object) {
        this.code = object.code
        this.name = object.name
    }
}